import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { Row, Col, Button, Dropdown, Menu, Modal, Select, message } from 'antd'
import { DownOutlined } from '@ant-design/icons'
import _ from 'lodash'
import '../../css/customer.scss'
import { Link } from 'react-router-dom'
import { constants } from '../../constants'
import MoveAIMessageModal from './moveai.message.modal'
import {
  fechactioncase,
  getCaseStats,
  bulkUpdateActionCases,
  fetchHealthCoachList,
} from '../../store/action/actioncases.action'
import { stripMessageScope } from '../../util/messagefilter'

const { ACTION_CASE_STATUS, ACTION_CASE_BULK } = constants

// Chip key doubles as the quick-filter value: a status value filters on that
// status, 'total' clears the status filter, 'unread' filters on the NEW flag.
const STAT_CHIPS = [
  { key: 'total', label: 'Total', stat: 'total' },
  { key: ACTION_CASE_STATUS.ASSIGNED, label: 'Assigned', stat: 'assigned' },
  {
    key: ACTION_CASE_STATUS.UNASSIGNED,
    label: 'Unassigned',
    stat: 'unassigned',
  },
  {
    key: ACTION_CASE_STATUS.UNRESOLVED,
    label: 'Unresolved',
    stat: 'unresolved',
  },
  { key: ACTION_CASE_STATUS.RESOLVED, label: 'Resolved', stat: 'resolved' },
  {
    key: ACTION_CASE_STATUS.NOTANISSUE,
    label: 'Not an issue',
    stat: 'notanissue',
  },
  { key: 'unread', label: 'Unread', stat: 'unread' },
]

function ActionCaseBarComponent(props) {
  const [messageOpen, setMessageOpen] = useState(false)
  const [assignOpen, setAssignOpen] = useState(false)
  const [assignee, setAssignee] = useState(null)

  // A health coach is themselves the assignee pool — no bulk assign for them.
  const isHealthCoach = !!props.hcId

  useEffect(() => {
    if (!isHealthCoach && props.companyId && _.isEmpty(props.healthCoachList)) {
      props.getHealthCoachList({ companyid: props.companyId })
    }
  }, [props.companyId])

  const filters = props.filters || {}
  const selectedKeys =
    (props.selectedRequests && props.selectedRequests.key) || []
  const caseStats = props.caseStats || {}

  const activeStatus = filters.unreadOnly
    ? 'unread'
    : filters.status && filters.status.length == 1
      ? filters.status[0]
      : 'total'

  const baseFilter = () => stripMessageScope({ ...filters })

  const runFetch = (filter) => {
    props.fetchActionCase(
      {
        metadata: { current: 1, pageSize: props.metaData?.pageSize || 20 },
        filters: filter,
        sorter:
          props.sorter && props.sorter.field
            ? props.sorter
            : { field: 'lastUpdated', order: 'descend' },
      },
      undefined,
      true,
      false
    )
  }

  const applyStatusFilter = (key) => {
    const filter = baseFilter()
    delete filter.status
    delete filter.unreadOnly
    if (key == 'unread') filter.unreadOnly = true
    else if (key != 'total') filter.status = [key]
    runFetch(filter)
  }

  const runBulk = async (action, healthCoachId) => {
    if (selectedKeys.length == 0) return
    const res = await props.bulkUpdateActionCases({
      caseIds: selectedKeys,
      action,
      healthCoachId,
    })
    if (res && !res.error) {
      message.success('Cases updated')
      runFetch(baseFilter())
      props.getCaseStats()
    }
  }

  const actionsMenu = (
    <Menu
      onClick={({ key }) => {
        if (key == ACTION_CASE_BULK.ASSIGN) {
          setAssignOpen(true)
          return
        }
        runBulk(key)
      }}
    >
      <Menu.Item key={ACTION_CASE_BULK.READ}>Mark as read</Menu.Item>
      <Menu.Item key={ACTION_CASE_BULK.UNREAD}>Mark as not read</Menu.Item>
      <Menu.Item key={ACTION_CASE_BULK.RESOLVE}>Resolved</Menu.Item>
      <Menu.Item key={ACTION_CASE_BULK.UNRESOLVE}>Unresolved</Menu.Item>
      <Menu.Item key={ACTION_CASE_BULK.NOTANISSUE}>Not an issue</Menu.Item>
      {!isHealthCoach && (
        <Menu.Item key={ACTION_CASE_BULK.ASSIGN}>Assign to</Menu.Item>
      )}
    </Menu>
  )

  return (
    <>
      <Row className={'actionRow'}>
        <Col flex={10}>
          <Row className={'headerText'}>Cases</Row>
          <Row flex='100%' align='middle'>
            {STAT_CHIPS.map((c, i) => (
              <React.Fragment key={c.key}>
                <p
                  onClick={() => applyStatusFilter(c.key)}
                  style={{
                    cursor: 'pointer',
                    fontWeight: activeStatus == c.key ? 700 : 400,
                    textDecoration:
                      activeStatus == c.key ? 'underline' : 'none',
                  }}
                >
                  {`${c.label}: ${caseStats[c.stat] != null ? caseStats[c.stat] : '-'}`}
                </p>
                {i < STAT_CHIPS.length - 1 && (
                  <p style={{ padding: '0 6px' }}>|</p>
                )}
              </React.Fragment>
            ))}
          </Row>
          <Row align='middle' style={{ marginTop: 4 }}>
            <Dropdown
              overlay={actionsMenu}
              disabled={selectedKeys.length == 0}
              trigger={['click']}
            >
              <Button size='small'>
                Actions
                {selectedKeys.length > 0 ? ` (${selectedKeys.length})` : ''}
                <DownOutlined />
              </Button>
            </Dropdown>
          </Row>
        </Col>
        <Col>&nbsp;</Col>
        <Col style={{ alignSelf: 'center', marginLeft: 'auto' }}>
          <Row justify={'end'} align={'bottom'}>
            <Button
              className={'actionBtn'}
              style={{ marginRight: 8 }}
              onClick={() => setMessageOpen(true)}
            >
              Send Message
            </Button>
            <Link
              to={{
                pathname: '/cases-add',
                state: {
                  type: constants.ACTION_CASE_TITLE.SYSTEM_TECHNICAL,
                  back: '/cases',
                  HCid: props.hcId,
                },
              }}
            >
              <Button className={'actionBtn'}>ADD</Button>
            </Link>
          </Row>
        </Col>
      </Row>
      <Modal
        title='Assign selected cases'
        visible={assignOpen}
        okText='Assign'
        okButtonProps={{ disabled: !assignee }}
        onOk={async () => {
          await runBulk(ACTION_CASE_BULK.ASSIGN, assignee)
          setAssignOpen(false)
          setAssignee(null)
        }}
        onCancel={() => {
          setAssignOpen(false)
          setAssignee(null)
        }}
      >
        <Select
          style={{ width: '100%' }}
          placeholder='Select assignee'
          showSearch
          value={assignee}
          filterOption={(input, option) =>
            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
          }
          onChange={(value) => setAssignee(value)}
        >
          {(props.healthCoachList || [])
            .map((user) => ({
              id: user._id,
              name: user.firstname + ' ' + user.lastname,
            }))
            .sort((a, b) => a.name.localeCompare(b.name))
            .map((item) => (
              <Select.Option key={item.id} value={item.id}>
                {item.name}
              </Select.Option>
            ))}
        </Select>
      </Modal>
      <MoveAIMessageModal
        visible={messageOpen}
        onClose={() => setMessageOpen(false)}
      />
    </>
  )
}

const mapStateToProps = (state) => {
  return {
    caseStats: state.actioncase.caseStats,
    filters: state.actioncase.filters,
    metaData: state.actioncase.metadata,
    sorter: state.actioncase.sorter,
    healthCoachList: state.actioncase.healthCoachList,
    selectedRequests: state.message.selectedRequests,
    companyId: state.profile?.company?._id,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    fetchActionCase: (params, select, ischeck, isNewMsg) =>
      dispatch(fechactioncase(params, select, ischeck, isNewMsg)),
    getCaseStats: (customerid) => dispatch(getCaseStats(customerid)),
    bulkUpdateActionCases: (params) => dispatch(bulkUpdateActionCases(params)),
    getHealthCoachList: (params) => dispatch(fetchHealthCoachList(params)),
  }
}

export const ActionCaseBar = connect(
  mapStateToProps,
  mapDispatchToProps
)(ActionCaseBarComponent)
